<template>
<div v-if="stats.length>0">
  <v-card class="stats">
    <v-card-title class="title justify-center">
      {{$t('stats.stats')}}
    </v-card-title>
    <v-layout>
      <v-flex xs4 pa-2>
        <v-menu v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" full-width lazy
                min-width="290px"
                offset-y transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dateFrom" :label="`${$t('form.search.from')}`" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="dateFrom" @input="menuFrom = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs4 pa-2>
        <v-menu v-model="menuTo" :close-on-content-click="false" :nudge-right="40" full-width lazy
                min-width="290px"
                offset-y transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dateTo" :label="`${$t('form.search.to')}`" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="dateTo" @input="menuTo = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-btn @click="load" color="primary" slot="activator">
        {{ $t('stats.load') }}
      </v-btn>
    </v-layout>
    <v-progress-circular v-if="chartLoading" :size="70" :rotate="30" :width="5" class="loading-circle" indeterminate></v-progress-circular>

    <div class="stats" v-else v-for="stat in stats" :key="stat.id">

      <component :is="stat.type + '-stats'" :id="stat.id" :categories="stat.categories" :dateFrom="dateFrom" :dateTo="dateTo"
                 :series="stat.series"
                 :title="stat.title"></component>


    </div>
  </v-card>
  <v-divider />
</div>
</template>

<script>
import http from '@/plugins/http'
import apexcharts from 'vue-apexcharts'
import LineStats from './charts/LineStats'
import BarStats from './charts/BarStats'
import StackedBarStats from './charts/StackedBarStats'
import ColumnStats from './charts/ColumnStats'

export default {
  components: {
    'apex-chart': apexcharts,
    'line-stats': LineStats,
    'bar-stats': BarStats,
    'column-stats': ColumnStats,
    'stackedbar-stats': StackedBarStats
  },
  data() {
    return {
      chartLoading: false,
      chartData: [],
      stats: [],
      dateTo: '',
      dateFrom: '',
      menuTo: '',
      menuFrom: ''

    }
  },
  computed: {},
  created() {
    this.load()
  },
  methods: {
    load() {
      let params = '?'
      if (this.dateFrom != "")
        params += 'from=' + this.dateFrom + '&'
      if (this.dateTo != "")
        params += 'to=' + this.dateTo

      http.get('statistics/stats/' + this.$route.params.schemaId + params)
        .then(({
          data
        }) => {
          this.stats = data
          this.chartLoading = false
        }).catch(() => {
          this.chartLoading = false
        })
    }
  },
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.stats {
  margin-top: 2.5rem;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}
</style>
